<template>
  <router-link v-if="isValidLink(slotData)" :to="generateLink(slotData)">
    {{ linkText }}
    {{ linkedItem[slotData.decorator || ""] || "" }}
  </router-link>
  <span v-else>
    {{ linkText }}
  </span>
</template>

<script>
export default {
  name: "RelatedLinkItem",
  props: {
    slotData: {
      type: Object
    },
    item: {
      type: Object
    }
  },
  computed: {
    linkedItem() {
      return this.item[this.slotData.name];
    },
    linkText() {
      return this.linkedItem.name;
    }
  },
  methods: {
    isValidLink(slot) {
      let link = this.generateLink(slot);
      for (let key in link.params) {
        if (!link.params[key]) {
          delete link.params[key];
        }
      }
      return Object.keys(link.params).length > 0;
    },
    generateLink(slot) {
      let link = {
        name: this.linkedItem.to || slot.to,
        params: {
          ...(slot.staticLinkParams || {})
        },
        query: {}
      };
      let linkParams = slot.linkParams || { id: "id" };
      let linkQuery = slot.linkQuery || {};
      for (let [key, value] of Object.entries(linkParams)) {
        link.params[key] = this.linkedItem[value];
      }
      for (let [key, value] of Object.entries(linkQuery)) {
        link.query[key] = this.linkedItem[value];
      }
      return link;
    }
  }
};
</script>

<style scoped></style>
